import { createFileRoute } from '@tanstack/react-router';
import { OutboxRouteView } from '@/pages/workspaces/journeys/outbox/outbox-route-view';

// The Message activity page, without the `journeys` segment. The old `journeys/outbox` and
// `journeys/message_activity` URLs forward here.
function MessageActivityRoute() {
  const { workspaceId, _splat } = Route.useParams();
  return <OutboxRouteView mount="hydra" workspaceId={workspaceId} splat={_splat ?? ''} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/message_activity/$')({
  component: MessageActivityRoute,
});
